import mime from "mime";

/**
 * Gets the MIME type for a given file extension
 * @param extension - File extension (with or without leading dot)
 * @returns MIME type string
 * @throws Error if the extension is not recognized
 */
export function getContentTypeFromExtension(extension: string): string {
  if (!extension) {
    throw new Error("Extension is required");
  }

  // Remove leading dot if present
  const cleanExtension = extension.startsWith(".") ? extension.slice(1) : extension;

  const type = mime.getType(cleanExtension);
  if (type == null) {
    throw new Error(`Unknown media extension: ${cleanExtension}`);
  }

  return type;
}

export function getFileExtension(file: File): string {
  const name = file.name ?? "";
  const dot = name.lastIndexOf(".");
  const ext = dot > 0 && dot < name.length - 1 ? name.slice(dot + 1).toLowerCase() : "";

  const looksInvalid = !ext || ext.length > 10 || /[^a-z0-9]/i.test(ext);

  if (!looksInvalid) return ext;

  return getExtensionFromContentType(file.type);
}

/**
 * Gets the file extension for a given MIME type
 * @param contentType - MIME type string
 * @returns File extension (without leading dot)
 * @throws Error if the content type is not recognized
 */
export function getExtensionFromContentType(contentType: string): string {
  if (!contentType) {
    throw new Error("Content type is required");
  }

  const extension = mime.getExtension(contentType);
  if (extension == null) {
    throw new Error(`Unknown content type: ${contentType}`);
  }

  return extension;
}
